import Vue from 'vue';
import Vuex from 'vuex';
import view from './popUpPreview'
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
    	promotion:view
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js